import { render } from "./ConfirmPopUp.vue?vue&type=template&id=2a3f829a"
import script from "./ConfirmPopUp.vue?vue&type=script&lang=js"
export * from "./ConfirmPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__